import { component } from "picoapp";
import { handleize } from "../../../../scripts/lib/utils";
import { type Context, type SelectedVariant } from "../../../state";

const updateSectionVisibility = ({
  node,
  titleHandle,
  variant,
}: {
  node: HTMLElement;
  titleHandle: string;
  variant: SelectedVariant;
}) => {
  if (handleize(variant?.title) === titleHandle) {
    node.classList.remove("hidden");
  } else {
    node.classList.add("hidden");
  }
};

const handleSectionVisibility = (node: HTMLElement, context: Context) => {
  const variantVisibleTitleHandle = node?.dataset?.variantVisibleTitleHandle;
  if (variantVisibleTitleHandle) {
    context.on("tbsp:variant-selected", ({ selectedVariant }) => {
      updateSectionVisibility({
        node,
        titleHandle: variantVisibleTitleHandle,
        variant: selectedVariant,
      });
    });
  }
};

export const fullScreenHero = component<Context>(
  (node: HTMLElement, context: Context) => {
    handleSectionVisibility(node, context);
  }
);

export const splitScreenHero = component<Context>(
  (node: HTMLElement, context: Context) => {
    handleSectionVisibility(node, context);
  }
);
